<template>
    <div class="px-4 py-4 main-container sm:px-6">
        <div class="h-full">
            <div class="mt-5 scrollable">
                <files :patient_id="patient.id"></files>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Files from "./Files";

export default {
    data: () => {
        return {
            loaded: false
        };
    },

    components: {
        Files
    },

    computed: {
        ...mapState("patient", ["patient"])
    }
};
</script>
